import { render, staticRenderFns } from "./AvukatTalepPicker.vue?vue&type=template&id=27ba8946&scoped=true"
import script from "./AvukatTalepPicker.vue?vue&type=script&lang=ts"
export * from "./AvukatTalepPicker.vue?vue&type=script&lang=ts"
import style0 from "./AvukatTalepPicker.vue?vue&type=style&index=0&id=27ba8946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba8946",
  null
  
)

export default component.exports